export default "__VITE_ASSET__CyWKj8nS__"